import { getAgentConceptsInStep2Order } from './getAgentConceptsInStep2Order';
import type {
  AddedConcept,
  AgentConcept,
  AgentSection,
  ConditionArea,
} from '../state/createProjectSlice';
import type { AnnotationAgentRenderPromptRequest } from '../types/request';

// TODO: cleanup with cp_annotation_createproject_agent ff

interface BuildAgentRenderPromptRequestInput {
  conditionArea: ConditionArea | null;
  addedConcepts: AddedConcept[];
  concepts: Record<string, AgentConcept>;
  sections: AgentSection[];
}

/**
 * Builds the render-prompt body from the saved builder configuration. Concepts follow the
 * step 2 order and carry the step 2 attribute IDs; the server resolves the labels. Card and
 * section drafts live in component state, so they never reach this function.
 *
 * Returns null while there is no condition to render against.
 */
export const buildAgentRenderPromptRequest = ({
  conditionArea,
  addedConcepts,
  concepts,
  sections,
}: BuildAgentRenderPromptRequestInput): AnnotationAgentRenderPromptRequest | null => {
  if (!conditionArea) return null;

  return {
    conditionAreaId: conditionArea.id,
    concepts: getAgentConceptsInStep2Order(addedConcepts, concepts).map(
      ({ conceptGroupId, concept, requiredAttributes }) => ({
        conceptGroupId,
        name: concept.name,
        synonyms: concept.synonyms,
        notes: concept.notes,
        requiredAttributeIds: requiredAttributes.map(({ id }) => id),
      })
    ),
    sections: sections.map(({ heading, body }) => ({ heading, body })),
  };
};
